<app-kpi-widget
  [title]="'driverDashboard.widgets.stationaryDrivers' | transloco"
  [isLoading]="isLoading"
  [icon]="'ph-bus'"
  [totalValue]="value"
  [valueFormatter]="formatValue"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  (clicked)="openStationaryDriverModal()"
  [widgetDisabled]="false"
  [dropdownEnabled]="false"
  [isImageIcon]="false"
  [hasFooter]="false"
  [percentageDifferenceEnabled]="false"
  [hasValueOnly]="true">
</app-kpi-widget>